import { render, staticRenderFns } from "./SchoolDashboard.vue?vue&type=template&id=5e407a45"
import script from "./SchoolDashboard.vue?vue&type=script&lang=js"
export * from "./SchoolDashboard.vue?vue&type=script&lang=js"
import style0 from "./SchoolDashboard.vue?vue&type=style&index=0&id=5e407a45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VRow,VSkeletonLoader})
